import { getRouterState } from '@atlassian/react-resource-router';
import { getTaskId } from './getTaskId.tsx';

type CorrelatedTaskId = string | undefined;

type CorrelatedTaskIdInput = {
	experience: string;
	explicitTaskId?: CorrelatedTaskId;
};

/**
 * Attaches the correlating SSR `taskId` to a terminal event, but only for the
 * experience the current route opts into SSR `taskStart` emission for (via
 * `analyticsOptions.taskStart` — the same route config the SSR side uses). This
 * keeps the client in sync with SSR and avoids attaching the SSR trace to
 * unrelated experiences, without hardcoding experience names.
 */
export const getCorrelatedTaskIdAttributes = ({
	experience,
	explicitTaskId,
}: CorrelatedTaskIdInput): { taskId?: CorrelatedTaskId } => {
	if (getRouterState().route?.analyticsOptions?.taskStart?.experience !== experience) {
		return {};
	}

	const taskId = getTaskId() ?? explicitTaskId;

	return taskId ? { taskId } : {};
};
